import { render, staticRenderFns } from "./add-topic.html?vue&type=template&id=2adc8b80&scoped=true&"
import script from "./add-topic.js?vue&type=script&lang=js&"
export * from "./add-topic.js?vue&type=script&lang=js&"
import style0 from "./add-topic.css?vue&type=style&index=0&id=2adc8b80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adc8b80",
  null
  
)

export default component.exports